import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './css/AddCaptain.css';
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
// import captain_json from './js/captains.json'
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios'
import { DBContext } from './DBContext'

function AddCaptain() {

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const { logginedDB, userType } = useContext(DBContext);

    const location = useLocation()

    const [userDetails,setUserDetails] = useState(null)
    const [uType,setUType] = useState(null)
    
    useEffect(() => {
        if (location.state) {
            setUserDetails(location.state.userDetails)
            setUType(location.state.type)
        }
    },[location])

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            width: '100%',
            backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF', 
            backgroundColor: state.isFocused ? '#c8cbcf' : '#FFF',
            color: state.isFocused ? '#000' : '#000',
            ':active': {
                ...provided[':active'],
                backgroundColor: '#c8cbcf'
              }
        }),
        input: (provided) => ({
            ...provided,
            // height: '2.5rem',
            width: '100% !important',
            cursor: 'none',
            '&:hover': {
                cursor: 'text'
            },
            '&:focus': {
                cursor: 'default',
            },
            // display: 'none', 
          }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: 'hidden', 
          }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            // display: 'none', 
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            height: '2.5rem', // Adjust height of dropdown indicator to match control height
            marginTop: 0, // Adjust vertical alignment if needed
        }),
        control: (provided, state) => ({
            ...provided,
            width: '100% !important',
            height: '2.5rem',
            fontSize: '1em',
            height: '2.5rem',
            border: '1px solid #C6C6C6',
            borderRadius: '0.313rem',
            textAlign: 'left',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #C6C6C6', 
            },
            '&:focus': {
            outline: 'none', // Remove outline on focus
            cursor: 'default', // Remove cursor on focus
            },
        }),
        placeholder: (provided, state) => ({
            ...provided,
            fontSize: '1rem',
            // lineHeight: '2.5rem',
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: '.9rem',
            textAlign: 'left',
            // height: '2.5rem',
        }),
    };;

    const [options,setOptions] = useState([])
    

    const handleGetUserTypes = async () => {
        try {
            const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER') || '';
            const loggedInUserType = userType ? userType.replace(/^"|"$/g, '').trim() : '';
            const response = await axios.get(`${apiBaseUrl}/getUserForReg/${logginedDB}?loggedInUser=${loggedInUser}&loggedInUserType=${loggedInUserType}`)
            if (response.status === 200) {
                const transformedData = response.data.map(item => ({
                    value: item.id,
                    label: item.userType
                }));
                setOptions(transformedData);
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        if (logginedDB) {
            handleGetUserTypes()
        }
    },[logginedDB])

    const initialForm = {
        Name:"",
        UserType:"",
        Username:"",
        UserCode:"",
        Password:"",
        Phone:"",
        UserPassword:"",
        SwipeCode:""
    }
    const [captain,setCaptain] = useState(initialForm)

    const [selectedOption,setSelectedOption] = useState(null)
    const [captainRights,setCaptainRights] = useState(false)

    const handleCaptain = (e, fieldName) => {
        if (userDetails) {
            if (fieldName === "UserType") {
                setSelectedOption(e)
                setUserDetails(prev => ({
                    ...prev,
                    'userType': e.value
                }));
            } else {
                let field;
                if (fieldName === "Name") field = 'userFullName'
                if (fieldName === "Username") field = 'userName'
                if (fieldName === "UserCode") field = 'userCode'
                if (fieldName === "SwipeCode") field = 'swipeCode'
                if (fieldName === "Password") field = 'userPassword'
                if (fieldName === "Phone") field = 'userMob'
                const value = e.target.value;
                setUserDetails(prev => ({
                    ...prev,
                    [field]: value
                }));
            }
        } else {
            if (fieldName === "UserType") {
                setSelectedOption(e)
                setCaptain(prevCaptain => ({
                    ...prevCaptain,
                    [fieldName]: e.value
                }));
            } else {
                const value = e.target.value;
                setCaptain(prevCaptain => ({
                    ...prevCaptain,
                    [fieldName]: value
                }));
            }
        }
    };

    const navigate = useNavigate(null)
    const handleSavebutton = async () => {
        let aalert;

        if (userDetails) aalert = `Update details ?`
        else aalert = `Add ${captain.Name} as ${selectedOption.label} ?`

        const userConfirmed = window.confirm(aalert);
        console.log(userDetails, "userDetails");
        
        if (!userConfirmed) {
            return;
        }

        try {
            let response;
            const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER') || '';
            const loggedInUserType = userType ? userType.replace(/^"|"$/g, '').trim() : '';

            if (userDetails) response = await axios.post(`${apiBaseUrl}/updateUser/${logginedDB}?loggedInUser=${loggedInUser}&loggedInUserType=${loggedInUserType}`, userDetails)
            else response = await axios.post(`${apiBaseUrl}/addUsers/${logginedDB}?loggedInUser=${loggedInUser}&loggedInUserType=${loggedInUserType}`, captain)

            if (response.status === 200) {
                if (userDetails) toast.success(`User details updated!`, {
                                    className: 'custom-toast',
                                    bodyClassName: 'custom-toast-container',
                                    closeButtonClassName: 'custom-toast-close-button',
                                    onClose: () => { }
                                });
                navigate('/BillerApp')
            }
        } catch (error) {
            toast.error(error?.response?.data || 'Something went wrong. Please try again.', {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
            });
        }
    }
    const toNavigateback = () => {
        navigate('/BillerApp')
    }

    const [disabled,setDisabled] = useState(true)

    const handleDisabled = () => {
        if (disabled) {
            const userConfirmed = window.confirm('Are you sure, you want to change usertype?');
            if (!userConfirmed) {
                return;
            }
            setDisabled(a=>!a)
        }
    }

  return (
    <div className='TableRegMainDiv'>
            <SherDineNav/>
            <div className='w-full bg-[#f5f5f5] flex gap-3 h-full'>
                <div className='w-max h-full z-[9999]'>
                    <SideNav focus={'User'}/>
                </div>
                <div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3'>
                    <div className="pr-3 h-max w-full bg-[#fff] borderBottom">
                        <TopRootDiv  image={'Menu Management'} root={['User Management']} section={'Add User'} isModify={userDetails}/>
                    </div>
                    <div className='w-full h-full flex flex-col gap-3 relative'>
                        <div className='w-full h-max flex bg-[#fff] p-2 text-[1rem] font-nunito'>
                            <span className='w-1/2 font-[600] flex justify-start items-center'>{!uType && 'User'} Details</span>
                            <div className='w-1/2 font-[500] flex justify-end items-center gap-3'>
                                <button className='loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 focus:outline-none' onClick={toNavigateback}>Cancel</button>
                                <button className='bg-[#0008B4] text-[#fff] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 focus:outline-none' onClick={handleSavebutton}>Save</button>
                            </div>
                        </div>
                        <div className='bg-[#fff] p-3 h-full flex flex-col gap-3' id="contentContainer">
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>Name</span>
                                    <input type="text" value={userDetails ? userDetails.userFullName : captain.Name} onChange={(e) => handleCaptain(e,'Name')}/>
                                </div>
                                <div className='Reg_input_div Reg_select_div'>
                                    <div className='w-full flex text-[1rem]'>
                                        <span className='w-full text-left'>User Type</span>
                                        {
                                            userDetails && (
                                                <span className='w-max text-right text-nowrap text-[#0008B4] cursor-pointer hover:underline' onClick={handleDisabled}>{disabled && 'Enable'}</span>
                                            )
                                        }
                                    </div>
                                    <Select
                                    styles={customStyles}
                                    value={
                                        userDetails 
                                            ? options.find(option => option.value === userDetails.userType) 
                                            : selectedOption
                                    }
                                    onChange={(e) => handleCaptain(e,'UserType')}
                                    options={options}
                                    isDisabled={userDetails && disabled}
                                    />
                                </div>
                            </div>
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>User Name</span>
                                    <input type="text" value={userDetails ? userDetails.userName : captain.Username} onChange={(e) => handleCaptain(e,'Username')} />
                                </div>
                                <div className='Reg_input_div'>
                                    <span>User Code</span>
                                    <input type="number" value={userDetails ? userDetails.userCode : captain.UserCode} onChange={(e) => handleCaptain(e,'UserCode')} />
                                </div>
                            </div>
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>Swipe Code</span>
                                    <input type="text" value={userDetails ? userDetails.swipeCode : captain.SwipeCode} onChange={(e) => handleCaptain(e,'SwipeCode')} />
                                </div>
                                <div className='Reg_input_div'>
                                    <span>Phone</span>
                                    <input type="number" value={userDetails ? userDetails.userMob : captain.Phone} onChange={(e) => handleCaptain(e,'Phone')} />
                                </div>
                            </div>
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>Password</span>
                                    <input type="password" value={userDetails ? userDetails.userPassword : captain.Password} onChange={(e) => handleCaptain(e,'Password')} />
                                </div>
                                <div className='Reg_input_div'>
                                    <span>Confirm Password</span>
                                    <input type="password" value={captain.UserPassword} onChange={(e) => handleCaptain(e,'UserPassword')} />
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
  )
}

export default AddCaptain
